<template>
  <div class="mx-2">
    <v-list v-if="table_artists.length > 0" two-line class="mx-0 px-0 mb-2">

      <template v-for="(item, index) in table_artists">
        <!-- {{item.accession_number}} <b>{{ item.title }}</b> -->

        <!-- <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader> -->
        <!-- <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider> -->
        <v-list-tile :key="item.id">{{item.key}}
          <!-- <v-list-tile-avatar> -->
          <!-- <v-list-tile-action style="width:150px; text-align:center;" class="my-0 mx-0 px-0 text-xs-center align-center justify-center"> -->
            <!-- <img v-if="item.top_photo_id>0"
              v-bind:src="'http://tb-cms.org/data/artist/' + item.id + '/' + item.top_photo_id + '_th.jpg'" 
            /> -->
          <!-- </v-list-tile-action> -->
          <!-- </v-list-tile-avatar> -->
          <v-list-tile-avatar v-if="c_user.delete_rights">
              <!-- <td> -->
            <v-tooltip right>
              <template #activator="data">
                <span v-on="data.on">
                  <v-btn style="width:20px; height:20px" round color="red" icon small dense @click="remove_from_text(item.id)" hint="Remove Artist from Text"> 
                    <v-icon small dense color=white>remove</v-icon>
                  </v-btn>                    
                </span>
              </template>
              Remove Artist from Text
            </v-tooltip>                
                <!-- <v-icon class="ml-2" small>edit</v-icon> -->
              <!-- </td> -->
          </v-list-tile-avatar>
          <v-list-tile-content class="ml-0 pl-0">
            <v-list-tile-sub-title class="subheading">
              <router-link :to="{ name: 'EditArtist', params: {id: item.id, artist: item}, path: `/artists/edit/${item.id}`}">
                <b>{{ item.name }}</b>
                <!-- <v-icon class="ml-2" small>edit</v-icon> -->
              </router-link> 
              <!-- <router-link :to="{ name: 'ViewArtist', params: {id: item.id, artist: item}, path: `/artists/view/${item.id}`}" >
                {{ item.title }}
              </router-link> -->
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              {{get_location_name(item.artist_location_id)}}
              <!-- {{item.artist_location.name}} -->
              <!-- <span class="text-truncate">{{item.credit}}</span> -->
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

      </template>

    </v-list>

    <template v-else>
      <p class="my-0 mx-0 px-0 text-xs-left align-left justify-left">No Artists</p>
    </template>

  </div>
</template>

<script>
  export default {
    props:['artist','artists','text_id'],
    computed: {
      table_artists () {
        // console.log('this.artists')
        // console.log(this.artists)
        // console.log(this.artists.map(am => am.id))
        // console.log(this.$store.state.artists.filter(a => (this.artists.map(am => am.id)).includes(a.id)))
        return this.$store.state.artists.filter(a => (this.artists.map(am => am.id)).includes(a.id))
      }
    },
    methods: {
      remove_from_text (artist_id) {
        // console.log(list_id)
        // console.log(artist_id)
        var text = Object.assign({},this.$store.state.texts.find(e => e.id == this.text_id))
        // console.log(list)
        text.artists = text.artists.filter(a => a != artist_id)
        // let url = `${this.$globals.apiserver}/lists.json`
        // axios.post(url).then((response) => {
        //   this.loading = false;
          // this.resultsArtists = response.data
        this.$store.dispatch('removeArtistFromText', {e: this.text_id, a: artist_id})
          // this.displayedData = response.data

        // }).catch((error) => { console.log(error) })
        // console.log(text)
      },        
      // artist_artworks (artist_id) {
      //   var a = Object.assign([],this.$store.state.artists)
      //   // console.log('artist_id')
      //   // console.log(artist_id)
      //   // console.log(a.artist_id == artist_id)
      //   var aa = a.filter(a => {
      //     // console.log('a.artist_id')
      //     // console.log(a.artist_id)
      //     // console.log(artist_id)
      //     return a.artist_id === artist_id}
      //   )
      //   // console.log(aa)
      //   return aa
      // },
      clear_selection () {
        this.$store.dispatch('clearCurrentSelection')
        this.selected = []
      },
      select_all () {
      },
      save_currently_selected(a,b) {
        // console.log('///////////')
        // console.log('a = ' + a)
        // console.log('b = ' + b.id)
        setTimeout(function () {
          var temp_selection = Object.assign([], this.$store.state.currentSelection)
          //// console.log(temp_selection)
          if (!a) {
            // console.log('a true')
            if (!temp_selection.includes(b)) {
              // console.log('doesnt include')
              temp_selection.push(b)
            }
          } else {
            // console.log('false')
            var index = temp_selection.indexOf(b);
            // console.log('index = ' + index)
            temp_selection.splice(index,1)
          }
          // this.$store.state.currentSelection
          // console.log(temp_selection)
          // this.selected.forEach(s => {
          //   if (!temp_selection.includes(s)) {
          //     temp_selection.push(s)
          //   }
          // })
          // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
          this.$store.dispatch('saveCurrentSelection',temp_selection)
        }.bind(this),1000)
      },
      save_currently_selected_all(a) {
        // console.log('///////////')
        // console.log('a = ' + a)
        var temp_selection = Object.assign([], this.$store.state.currentSelection)
        // console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b)
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index,1)
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection',temp_selection)
      },
      save_currently_selected_tags() {
        this.$store.dispatch('saveCurrentSelectionTags',this.selected_tags)
        this.ta = this.tagged_artists
      }      
    }
  }
</script>

<style scoped>
  a {text-decoration: none}
  a:hover {text-decoration: underline}
</style>


// WEBPACK FOOTER //
// src/components/texts/ListRelatedArtists.vue